// DO NOT EDIT -- generated from fs/services/paige/admin.proto

import { InvalidLabel, InvalidPattern, ValidationError } from './paige.proto';
import * as cloracle from '../../learn/cloracle';
import * as orgs from '../orgs';
import * as pages from '../../api/pages';
import * as protobuf from '../../../google/protobuf';

export namespace Admin {

  export const ComputeLearnedPagesEndpoint = "/grpc/paige.Admin/ComputeLearnedPages";
  export function ComputeLearnedPages(sender: (req: ComputeLearnedPagesRequest, endpoint: string) => Promise<{}>, req: ComputeLearnedPagesRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeLearnedPagesEndpoint),
      endpoint: ComputeLearnedPagesEndpoint
    };
  }

  export const FetchClusterMetadataEndpoint = "/grpc/paige.Admin/FetchClusterMetadata";
  export function FetchClusterMetadata(sender: (req: FetchClusterMetadataRequest, endpoint: string) => Promise<FetchClusterMetadataReply>, req: FetchClusterMetadataRequest): { promise: () => Promise<FetchClusterMetadataReply>, endpoint: string } {
    return {
      promise: () => sender(req, FetchClusterMetadataEndpoint),
      endpoint: FetchClusterMetadataEndpoint
    };
  }

  export const BulkArchiveEndpoint = "/grpc/paige.Admin/BulkArchive";
  export function BulkArchive(sender: (req: BulkArchiveRequest, endpoint: string) => Promise<BulkArchiveReply>, req: BulkArchiveRequest): { promise: () => Promise<BulkArchiveReply>, endpoint: string } {
    return {
      promise: () => sender(req, BulkArchiveEndpoint),
      endpoint: BulkArchiveEndpoint
    };
  }

  export const BulkDeleteEndpoint = "/grpc/paige.Admin/BulkDelete";
  export function BulkDelete(sender: (req: BulkDeleteRequest, endpoint: string) => Promise<BulkDeleteReply>, req: BulkDeleteRequest): { promise: () => Promise<BulkDeleteReply>, endpoint: string } {
    return {
      promise: () => sender(req, BulkDeleteEndpoint),
      endpoint: BulkDeleteEndpoint
    };
  }

  export const MigratePatternsEndpoint = "/grpc/paige.Admin/MigratePatterns";
  export function MigratePatterns(sender: (req: MigratePatternsRequest, endpoint: string) => Promise<MigratePatternsReply>, req: MigratePatternsRequest): { promise: () => Promise<MigratePatternsReply>, endpoint: string } {
    return {
      promise: () => sender(req, MigratePatternsEndpoint),
      endpoint: MigratePatternsEndpoint
    };
  }

  export const BulkMigratePatternsEndpoint = "/grpc/paige.Admin/BulkMigratePatterns";
  export function BulkMigratePatterns(sender: (req: BulkMigratePatternsRequest, endpoint: string) => Promise<BulkMigratePatternsReply>, req: BulkMigratePatternsRequest): { promise: () => Promise<BulkMigratePatternsReply>, endpoint: string } {
    return {
      promise: () => sender(req, BulkMigratePatternsEndpoint),
      endpoint: BulkMigratePatternsEndpoint
    };
  }

  export const BulkLoadOrgsEndpoint = "/grpc/paige.Admin/BulkLoadOrgs";
  export function BulkLoadOrgs(sender: (req: {}, endpoint: string) => Promise<BulkLoadOrgsReply>, req: {}): { promise: () => Promise<BulkLoadOrgsReply>, endpoint: string } {
    return {
      promise: () => sender(req, BulkLoadOrgsEndpoint),
      endpoint: BulkLoadOrgsEndpoint
    };
  }

  export const LoadOrgEndpoint = "/grpc/paige.Admin/LoadOrg";
  export function LoadOrg(sender: (req: LoadOrgRequest, endpoint: string) => Promise<{}>, req: LoadOrgRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, LoadOrgEndpoint),
      endpoint: LoadOrgEndpoint
    };
  }

  export const BulkPurgePagesEndpoint = "/grpc/paige.Admin/BulkPurgePages";
  export function BulkPurgePages(sender: (req: BulkPurgePagesRequest, endpoint: string) => Promise<BulkPurgePagesReply>, req: BulkPurgePagesRequest): { promise: () => Promise<BulkPurgePagesReply>, endpoint: string } {
    return {
      promise: () => sender(req, BulkPurgePagesEndpoint),
      endpoint: BulkPurgePagesEndpoint
    };
  }

  export const PurgePagesEndpoint = "/grpc/paige.Admin/PurgePages";
  export function PurgePages(sender: (req: PurgePageRequest, endpoint: string) => Promise<PurgePagesReply>, req: PurgePageRequest): { promise: () => Promise<PurgePagesReply>, endpoint: string } {
    return {
      promise: () => sender(req, PurgePagesEndpoint),
      endpoint: PurgePagesEndpoint
    };
  }

  export const BulkAddPlatformTagsEndpoint = "/grpc/paige.Admin/BulkAddPlatformTags";
  export function BulkAddPlatformTags(sender: (req: BulkAddPlatformTagsRequest, endpoint: string) => Promise<BulkAddPlatformTagsResponse>, req: BulkAddPlatformTagsRequest): { promise: () => Promise<BulkAddPlatformTagsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BulkAddPlatformTagsEndpoint),
      endpoint: BulkAddPlatformTagsEndpoint
    };
  }

  export const AddPlatformTagsEndpoint = "/grpc/paige.Admin/AddPlatformTags";
  export function AddPlatformTags(sender: (req: AddPlatformTagsRequest, endpoint: string) => Promise<AddPlatformTagsResponse>, req: AddPlatformTagsRequest): { promise: () => Promise<AddPlatformTagsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, AddPlatformTagsEndpoint),
      endpoint: AddPlatformTagsEndpoint
    };
  }

  export const MigratePagesEndpoint = "/grpc/paige.Admin/MigratePages";
  export function MigratePages(sender: (req: MigratePagesRequest, endpoint: string) => Promise<{}>, req: MigratePagesRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, MigratePagesEndpoint),
      endpoint: MigratePagesEndpoint
    };
  }

  export const ExportPagesEndpoint = "/grpc/paige.Admin/ExportPages";
  export function ExportPages(sender: (req: ExportPagesRequest, endpoint: string) => Promise<ExportPagesResponse>, req: ExportPagesRequest): { promise: () => Promise<ExportPagesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ExportPagesEndpoint),
      endpoint: ExportPagesEndpoint
    };
  }

  export const ImportPagesEndpoint = "/grpc/paige.Admin/ImportPages";
  export function ImportPages(sender: (req: ImportPagesRequest, endpoint: string) => Promise<ImportPagesResponse>, req: ImportPagesRequest): { promise: () => Promise<ImportPagesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ImportPagesEndpoint),
      endpoint: ImportPagesEndpoint
    };
  }

  export const PurgePageDefCacheEndpoint = "/grpc/paige.Admin/PurgePageDefCache";
  export function PurgePageDefCache(sender: (req: PurgePageDefCacheRequest, endpoint: string) => Promise<PurgePageDefCacheResponse>, req: PurgePageDefCacheRequest): { promise: () => Promise<PurgePageDefCacheResponse>, endpoint: string } {
    return {
      promise: () => sender(req, PurgePageDefCacheEndpoint),
      endpoint: PurgePageDefCacheEndpoint
    };
  }

  export const GetCaseConflictsEndpoint = "/grpc/paige.Admin/GetCaseConflicts";
  export function GetCaseConflicts(sender: (req: GetCaseConflictsRequest, endpoint: string) => Promise<GetCaseConflictsResponse>, req: GetCaseConflictsRequest): { promise: () => Promise<GetCaseConflictsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetCaseConflictsEndpoint),
      endpoint: GetCaseConflictsEndpoint
    };
  }

  export const FixCaseConflictsEndpoint = "/grpc/paige.Admin/FixCaseConflicts";
  export function FixCaseConflicts(sender: (req: FixCaseConflictsRequest, endpoint: string) => Promise<FixCaseConflictsResponse>, req: FixCaseConflictsRequest): { promise: () => Promise<FixCaseConflictsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, FixCaseConflictsEndpoint),
      endpoint: FixCaseConflictsEndpoint
    };
  }

  export const SetApiPageBlockRuleEndpoint = "/grpc/paige.Admin/SetApiPageBlockRule";
  export function SetApiPageBlockRule(sender: (req: SetApiPageBlockRuleRequest, endpoint: string) => Promise<SetApiPageBlockRuleResponse>, req: SetApiPageBlockRuleRequest): { promise: () => Promise<SetApiPageBlockRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetApiPageBlockRuleEndpoint),
      endpoint: SetApiPageBlockRuleEndpoint
    };
  }
}

export interface ComputeLearnedPagesRequest {
  orgId: string;
  /** overwrite existing learned pages with results of this request */
  persistChanges: boolean;
}

export interface FetchClusterMetadataRequest {
  orgId: string;
}

export interface FetchClusterMetadataReply {
  url: string;
}

export interface BulkDeleteRequest {
  orgId: string;
  /** comma-separated list of pages to delete */
  ids: string;
  /** really, permanently delete the entities */
  shouldDelete: boolean;
}

export interface BulkDeleteReply {
  deleted: number[];
}

export interface BulkArchiveRequest {
  orgId: string;
  /** comma-separated list of pages to archive */
  ids: string;
}

export interface BulkArchiveReply {
  archived: number[];
}

export interface MigratePatternsRequest {
  orgId: string;
  doMigration: boolean;
  expireInDays: number;
}

export interface MigratePatternsReply {
  migratedPatterns: MigratedPattern[];
}

export interface BulkMigratePatternsRequest {
  doMigration: boolean;
  planStages: orgs.PlanStage[];
  expireInDays: number;
}

export interface BulkMigratePatternsReply {
  migratedOrgs: MigratedPatterns[];
  orgsMigrated: number;
}

export interface BulkLoadOrgsReply {
  failedOrgs: string[];
}

export interface LoadOrgRequest {
  orgId: string;
}

export interface BulkPurgePagesRequest {
  doDeletes: boolean;
}

export interface BulkPurgePagesReply {
  deleted: { [key: string]: PurgePagesReply };
  failedOrgs: string[];
}

export interface PurgePageRequest {
  orgId: string;
  doDeletes: boolean;
}

export interface PurgePagesReply {
  deleted: pages.PageDefinition[];
}

export interface BulkAddPlatformTagsRequest {
  addTags: boolean;
  planStages: orgs.PlanStage[];
  ignoreAuditTrail: boolean;
}

export interface BulkAddPlatformTagsResponse {
  succeededOrgs: number;
  failedOrgs: string[];
}

export interface AddPlatformTagsRequest {
  addTags: boolean;
  orgId: string;
  ignoreAuditTrail: boolean;
}

export interface AddPlatformTagsResponse {
  defsTagged: number;
}

export interface LearnedPagesDebug {
  /** newly created learned pages */
  created: CreatedLearnedPage[];
  /** visit counts for all learned pages */
  pageVisits: { [key: string]: protobuf.int64 };
  /** page visit summary statistics */
  distribution: Distribution | null;
  /** threshold for pruning low traffic learned pages */
  minimumVisitCount: protobuf.int64;
  /** urls removed for matching user-defined page */
  matchedUserDefined: string[];
  /** breakdown of which pages were filtered or not, and why */
  filteredPages: FilteredLearnedPage[];
}

export interface Distribution {
  length: protobuf.int64;
  min: protobuf.int64;
  max: protobuf.int64;
  mean: number;
  standardDeviation: number;
}

export interface CreatedLearnedPage {
  learnedPage: pages.PageDefinition | null;
  /** child rules pruned by new learned page */
  archived: pages.PageDefinition[];
}

export interface FilteredLearnedPage {
  pattern: string;
  /** how many visits this page received */
  visits: protobuf.int64;
  /** minimum number of visits to be counted as a learned page */
  minimumVisits: protobuf.int64;
  /** penalty must reach this threshold to filter out a page */
  threshold: protobuf.int64;
  /** penalty assigned by heuristically scoring the pattern */
  penalty: protobuf.int64;
  /** was the learned page filtered out of not */
  filtered: boolean;
}

export interface MigratedPattern {
  pageId: number;
  pattern: string;
  newPattern: string;
  reason: InvalidPattern.Reason;
  labelReason: InvalidLabel.Reason;
  createdBy: string;
  updatedBy: string;
  lastUpdate: protobuf.timestamp | null;
}

export interface MigratedPatterns {
  orgId: string;
  patterns: MigratedPattern[];
}

export interface SavedClusterMetadata {
  clusters: cloracle.ClusterMetadata[];
}

export interface MigratePagesRequest {
  orgId: string;
  numWorkers: number;
  batchSize: number;
}

export interface ExportPagesRequest {
  orgId: string;
  excludeArchived: boolean;
}

export interface ExportPagesResponse {
  pagesCsv: string;
}

export interface ImportPagesRequest {
  orgId: string;
  pagesCsv: string;
  commitImport: boolean;
}

export interface ImportPagesResponse {
  errors: ValidationError[];
  pagesModified: pages.PageDefinition[];
  wasDestructive: boolean;
}

export interface PurgePageDefCacheRequest {
  orgId: string;
}

export interface PurgePageDefCacheResponse {
  wasPresent: boolean;
}

export interface GetCaseConflictsRequest {
  orgId: string;
}

export interface GetCaseConflictsResponse {
  patternConflicts: GetCaseConflictsResponse.ExistingPatternConflict[];
}

export namespace GetCaseConflictsResponse {
  export interface ExistingPatternConflict {
    firstDef: pages.PageDefinition | null;
    secondDef: pages.PageDefinition | null;
    firstDefIndex: number;
    secondDefIndex: number;
  }
}

export interface FixCaseConflictsRequest {
  orgId: string;
  /** only commit fix level changes if this is checked */
  doCommitChanges: boolean;
  /** only enforce force level fixes if this is checked */
  doForceCommits: boolean;
  /** fix case conflicts within groups */
  groupConflicts: FixCaseConflictsRequest.FixLevel;
  /** fix conflicts between patterns on the same def */
  selfConflicts: FixCaseConflictsRequest.FixLevel;
}

export namespace FixCaseConflictsRequest {
  export enum FixLevel {
    /** Do not fix this type of conflict */
    IGNORE = 0,
    /** Preview what this fix would do */
    PREVIEW = 1,
    /** Commit this fix iff all patterns would be covered by current settings */
    FIX = 2,
    /** Fix these, even if all patterns are not covered */
    FORCE_FIX = 3
  }
}

export interface FixCaseConflictsResponse {
  preview: FixCaseConflictsResponse.DefinitionCaseFix[];
  committed: FixCaseConflictsResponse.DefinitionCaseFix[];
  remainingConflicts: GetCaseConflictsResponse | null;
}

export namespace FixCaseConflictsResponse {
  export interface DefinitionCaseFix {
    originalDef: pages.PageDefinition | null;
    fixedDef: pages.PageDefinition | null;
  }
}

export interface PageBlockRules {
  blockRules: PageBlockRule[];
}

export interface PageBlockRule {
  pageName: string;
  treatNameAsPrefix: boolean;
}

export interface SetApiPageBlockRuleRequest {
  orgId: string;
  blockRules: PageBlockRules | null;
  state: SetApiPageBlockRuleRequest.State;
  commit: boolean;
}

export namespace SetApiPageBlockRuleRequest {
  export enum State {
    STATE_INVALID = 0,
    STATE_BLOCK = 1,
    STATE_UNBLOCK = 2
  }
}

export interface SetApiPageBlockRuleResponse {
  updatedBlockRules: PageBlockRules | null;
}
